<template>
	<div>
		<div class="pre-list-pic-card" v-for="(item, index) in ArrList" :key="index">
			<span class="card-span">
				<span class="span-icon" @click="previewPci(item)">
					<i class="el-icon-zoom-in"></i>
				</span>
				<span class="span-icon" style="margin-left: 15px;" @click="removePic(item)">
					<i class="el-icon-delete"></i>
				</span>
			</span>
			<img class="card-img" :src="item.url" :onerror="errorImgRectangle" alt="">
		</div>
	</div>
</template>

<script>
export default {
	name: 'noticeModal',
	props: {
		preType: {
			type: String,
			default: '',
		},
		ArrList: {
			type: Array,
			default() {
				return []
			}
		},
	},
	methods: {
		// 预览
		previewPci(item) {
			this.$emit('toPreview', item)
		},
		// 移除
		removePic(item) {
			this.$emit('toRemvove', item, this.preType)
		}
	},
}
</script>

<style lang="scss">
.pre-list-pic-card {
	display: inline-block;
	.card-img {
		background-color: rgba(0, 0, 0, .2);
		width: 300px;
		height: 100px;
		border-radius: 6px;
	}
	.card-span {
		text-align: center;
		border-radius: 6px;
		position: absolute;
		display: inline-block;
		width: 300px;
		height: 100px;
		line-height: 100px;
		opacity: 0;
		-webkit-transition: all .5s cubic-bezier(.55, 0, .1, 1);
		transition: all .5s cubic-bezier(.55, 0, .1, 1);
		.span-icon {
			cursor: pointer;
			font-size: 20px;
			color: #fff;
		}
	}
	.card-span:hover {
		opacity: 1;
		background-color: rgba(0, 0, 0, .5);
		-webkit-transition: all .3s;
		transition: all .3s;
	}
}
</style>